import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { CellContext } from '@tanstack/react-table'
import { FormData } from '../../DataFormComponent/types'
import { DataTableV2Action, DataTableV2DataRow, DataTableV2GroupConfig } from '../types'
import { GroupEditAction } from './GroupEditAction'
import { JsonFormPropertyV2 } from '../../FormComponent/types'
import { IconHorizontalMoreOutline } from '@icons/IconHorizontalMoreOutline'
import { RowActionV2 } from './RowActionV2'

export function RowActionsV2Menu<T, V>({
  info,
  rowActions,
  groupConfig,
}: {
  info: CellContext<T, V>
  rowActions: DataTableV2Action[]
  groupConfig?: DataTableV2GroupConfig
}) {
  const meta = info.table.options.meta as {
    isRegrouping: boolean
    updateGroup: (groupId: string, data: FormData, formProperties: JsonFormPropertyV2[]) => void
  }
  const isRegrouping = meta?.isRegrouping ?? false
  const isGroup = !!(info.row.original as DataTableV2DataRow).isGroup

  // const updateGroup = useCallback(
  //   (id: string, data: Record<string, unknown>) => {
  //     // meta?.updateGroup(id, data)
  //     console.log('updateGroup', id, data)
  //   },
  //   [meta]
  // )

  // Visibility logic:
  // - isRegrouping=true: Show ONLY on group rows
  // - isRegrouping=false: Show ONLY on subrows/orphaned rows (non-group)
  if (isRegrouping !== isGroup) return null
  if (!isRegrouping && rowActions.length === 0) return null
  const { updateGroup } = meta
  if (isRegrouping && groupConfig) {
    return (
      <GroupEditAction
        groupConfig={groupConfig}
        formData={info.row.original as DataTableV2DataRow}
        onSubmitOverride={updateGroup}
      />
    )
  }

  const inlineActions = rowActions.filter((action) => action.inDropdownMenu === false)
  const dropdownActions = rowActions.filter((action) => action.inDropdownMenu !== false)

  return (
    <div className="flex items-center gap-x-4">
      {inlineActions.map((action) => (
        <RowActionV2 key={action.id} action={action} info={info} displayAs="icon-button" />
      ))}
      {dropdownActions.length > 0 && (
        <DropdownMenu
          onOpenChange={(open) => {
            // This is necessary to maintain the open state when we want to keep it open
            if (!open) {
              // Check if we need to prevent closing
              // This is a placeholder for custom logic you might need
              // We'll use other mechanisms to prevent closing on item click
            }
          }}
        >
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="size-6">
              <IconHorizontalMoreOutline size={16} />
              <span className="sr-only">Open menu</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            onCloseAutoFocus={(e) => {
              // Prevent focus returning to trigger which can close the menu
              e.preventDefault()
            }}
          >
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {dropdownActions.map((action) => (
              <RowActionV2 key={action.id} action={action} info={info} displayAs="dropdown-item" />
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  )
}
